import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComplianceItem {
  standard: string;
  description: string;
  icon: string;
}

interface ComplianceSectionProps {
  title: string;
  description: string;
  items: ComplianceItem[];
}

const ComplianceSection = ({ title, description, items }: ComplianceSectionProps) => {
  return (
    <section className="py-16 bg-muted">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <Icon name="ShieldCheckIcon" size={32} variant="solid" className="text-success" />
            <h2 className="text-3xl md:text-4xl font-headline font-bold text-foreground">
              {title}
            </h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {description}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <div key={index} className="bg-card rounded-lg p-6 shadow-sm hover:shadow-md transition-all duration-base">
              <div className="flex items-start space-x-4">
                <div className="bg-success bg-opacity-10 p-3 rounded-lg flex-shrink-0">
                  <Icon name={item.icon as any} size={24} variant="solid" className="text-success" />
                </div>
                <div>
                  <h3 className="text-lg font-headline font-semibold text-foreground mb-2">
                    {item.standard}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;